// src/components/biometrics/BioStatusChips.tsx
import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";

function chipSx(color: "success" | "warning" | "error" | "default") {
	return (t: any) => {
		if (color === "default") {
			return {
				fontWeight: 600,
				borderRadius: 999,
				bgcolor: t.palette.grey[100],
				color: t.palette.text.secondary,
				border: "1px solid",
				borderColor: t.palette.divider,
			};
		}
		const p = t.palette[color];
		return {
			fontWeight: 600,
			borderRadius: 999,
			bgcolor: alpha(p.main, 0.08),
			color: p.dark,
			border: "1px solid",
			borderColor: alpha(p.main, 0.25),
		};
	};
}

export function StatusChip({ status }: { status?: string | null }) {
	const label = status === "authenticated" ? "Autenticado" : status === "pending" ? "Pendente" : status === "failed" ? "Falhou" : status || "—";

	const sx =
		status === "authenticated" ? chipSx("success") : status === "pending" ? chipSx("warning") : status === "failed" ? chipSx("error") : chipSx("default");

	return <Chip size="small" label={label} sx={sx} />;
}

export function IntegratorChip({ status }: { status?: string | null }) {
	if (!status) return null;
	const sx = status === "success" ? chipSx("success") : status === "failed" ? chipSx("error") : chipSx("default");
	return <Chip size="small" label={`Integrator: ${status}`} sx={sx} />;
}
